/// <reference path="./oidc-client.d.ts"/>

interface Window {
    DWOidc: {
        UserManager: Oidc.UserManager;
        Startup: {
            isAuthenticatedMode: boolean,
            settings: DWOidc.Settings;
            bootstrap: (mgr: Oidc.UserManager) => void;
            authRequired: boolean
        };
    };
};

namespace DWOidc {

    export interface Settings {
        ClientId: string,
        IdentityServiceUrl: string,
        BaseUrl: string,
        LoginRedirectCallbackPath: string,
        SilentRenewPath: string,
        OidsState: string,
        ExtraQueryParams: any
    }
    /*
    Oidc.Log.logger = console;
    Oidc.Log.level = Oidc.Log.DEBUG;
    */

    function isUserValid(user) {
        return user && !user.expired;
    }

    function tryGetUser(mgr: Oidc.UserManager) {
        let dfd = (window as any).DW.Deferred();

        mgr
            .getUser()
            .then((user) => {
                if (isUserValid(user))
                    dfd.resolve(user);
                else {
                    mgr.signinSilent()
                        .then(dfd.resolve, dfd.reject)
                        .catch(dfd.reject);
                }
            })
            .catch(dfd.reject);

        return dfd.promise();
    }

    const url = new (window as any).URL(window.location.href);
    const startUp = window.DWOidc.Startup;

    var settings = startUp.settings,
        options = {
            // The OpenID Connect base URL
            authority: settings.IdentityServiceUrl,

            // Core OAuth settings for our app
            client_id: settings.ClientId,
            redirect_uri: url.origin + settings.LoginRedirectCallbackPath,
            scope: "openid docuware.platform docuware.workflow.service docuware.idservice.api",

            // Use the Authorization Code Flow (PKCE)
            response_type: 'code',

            // TODO: Tokens are stored only in memory, which is better from a security viewpoint
            //userStore: new Oidc.WebStorageStateStore({ store: new Oidc.InMemoryWebStorage() }),

            // Store redirect state such as PKCE verifiers in session storage, for more reliable cleanup
            stateStore: new Oidc.WebStorageStateStore({ store: sessionStorage }),

            // Renew on the SPA's main URL and do so on demand
            silent_redirect_uri: url.origin + settings.SilentRenewPath,
            automaticSilentRenew: true,

            // Our Web UI gets user info from its API, for best extensibility
            loadUserInfo: false,

            // Indicate the logout return path and listen for logout events from other browser tabs
            post_logout_redirect_uri: url.origin + settings.BaseUrl,

            // Add additional params from serverside code
            extraQueryParams: settings.ExtraQueryParams,

            //Exclude token from the /authorize request as it exceeds the max length of 2048 symbols
            includeIdTokenInSilentRenew: false
        },
        mgr = new Oidc.UserManager(options),

        signinRedirect = function () {
            mgr.signinRedirect({
                state: {
                    redirectLocation: url.toString()
                }
            });
        };

    (mgr as any).getAuthHeader = function () {
        let dfd = (window as any).DW.Deferred();

        tryGetUser(this)
            .then((user) => {
                dfd.resolve({ 'Authorization': 'Bearer ' + user.access_token });
            }, (error) => {
                dfd.reject(null);
            })

        return dfd.promise();
    }

    mgr.events.addUserSignedOut(function () {
        mgr.removeUser().then(function () {
            mgr.clearStaleState();
            mgr.signinRedirect();
        });
    });

    if (settings.OidsState == "SilentRenew") {
        mgr.signinSilentCallback()
            .catch(function (err) {
                console.log('SilentRenew', err);
            });
    }
    else if (settings.OidsState == "SingleSignOn") {
        mgr.signinRedirect();
    }
    else if (settings.OidsState == "LoginCallback") {
        mgr.signinRedirectCallback().then(function (user) {
            var redirectUri = (user && user.state && user.state.redirectLocation) ? user.state.redirectLocation : settings.BaseUrl;
            window.history.replaceState({}, window.document.title, window.location.origin);
            window.location.href = redirectUri;
        }, function (err) {
            console.error(err);
        });
    } else {
        mgr.clearStaleState();
        tryGetUser(mgr).then((user) => {
            // We are authenticated
            mgr.events.addUserLoaded((args) => {
                mgr.getUser().then((oidcUser) => user = oidcUser);
            });

            startUp.bootstrap(mgr);
        }, function (err) {
            if (!startUp.authRequired) {
                startUp.bootstrap(mgr);
            } else {
                signinRedirect();
            }
        });
    }

    window.DWOidc.UserManager = mgr;

}